import styled, { css } from 'styled-components'
import { DefaultFontStyle } from '../../../../styles/global-styles'

export const GroupBookingTitleCommon = styled.span`
  ${DefaultFontStyle};
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #0b0a0a;
  margin: 0px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 18px;
    line-height: 27px;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 12px;
    line-height: 15px;
  }
  white-space: nowrap;
`
export const GroupBookingTitle = styled(GroupBookingTitleCommon)`
  margin-left: 40px;
`

export const ClubTitle = styled(GroupBookingTitleCommon)`
  font-weight: 400;
`

export const FlexBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
  }
  .autocomplete {
    width: 100%;
    padding: 25px 0;
  }
  .error input {
    border-color: red;
  }
  margin: 0px;
`
export const ColumnFlexBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const ErrorMessage = styled.div`
  ${DefaultFontStyle};
  color: #d82036;
  display: block;
  font-size: smaller;
  position: absolute;
  padding-right: 20px;
  text-align: left;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 10px;
    top: 200px;
  }
`

export const DuplicateErrorMessage = styled.div`
  ${DefaultFontStyle};
  color: #d82036;
  display: block;
  font-size: smaller;
  text-align: left;
  position: absolute;
  padding-right: 20px;
  top: 315px;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 10px;
    top: 300px;
  }
`

export const SelectedMemberBlock = styled.div`
  margin: 10px 0;
`

export const UserIcon = styled.img`
  margin-right: 10px;
  width: 25px;
  margin-top: 15px;
`

export const LocationIcon = styled.img`
  width: 20px;
`

export const ErrorIcon = styled.img<{ isLocationNotReady: boolean }>`
  width: 20px;
  margin-left: 5px;
  margin-top: ${props => (props.isLocationNotReady ? '2px' : '-30px')};
  position: relative;
  margin-right: ${props => (props.isLocationNotReady ? '5px' : '0px')};
`
export const LocationError = styled.div`
  display: flex;
  align-items: flex-start;
`

export const IconContainer = styled.div`
  width: 40px;
`
export const BookingChipContainer = styled.div<{ shouldScroll?: boolean }>`
  margin: 10px 0;
  display: grid;
  grid-template-columns: repeat(2, 50%);
  grid-template-rows: masonry;
  max-width: 100%;
  min-height: 100px;
  max-height: 258px;
  padding-bottom: 47px;

  ${props =>
    props.shouldScroll &&
    css`
      overflow-y: scroll;
    `}
`

export const AvailableSeatCounterIcon = styled.img`
  width: 15px;
  margin-left: 0px;
  margin-top: 9px;
`

export const ComboBoxIcon = styled.img`
  bottom: 13px;
  margin-left: 0px;
  position: relative;
  width: 15px;
`

export const SpacesAvailableText = styled.span`
  font-size: 16px;
  margin-top: 10px;
  margin-right: auto;
`
export const MemberAlreadyAdded = styled.div`
  font-size: 10px;
  color: red;
  margin-top: 5px;
  text-align: left;
`
